import { infrastructure } from '../constans/salePackageEnum';

const getSaleTypeName = (saleType) => {
    switch (saleType) {
      case null:
      case 0: return 'tv'; break;
      case 1: return 'app'; break;
      case 2: return 'cellular'; break;
      case 3: return 'internet'; break;
      case 4: return 'triple'; break;
      default: return 'tv';
    };
};
  
export const packageResponse = (selectedPackage) => {
    const infrastructureList = selectedPackage.infrastructures?.value?.map((item) => { return infrastructure[item.infrastructure] }) ?? [];
    return ({
      blockID: selectedPackage?.contentLink?.id,
      offerID: selectedPackage?.offerID?.value,
      saleType: getSaleTypeName(selectedPackage?.saleType?.value),
      infrastructures: infrastructureList,
      downloadSpeed: selectedPackage?.downloadSpeed?.value,
      uploadSpeed:selectedPackage?.uploadSpeed?.value,
      selectedRouterName: selectedPackage?.cellcomRouterName?.value,
      defaultConvertersAmount: selectedPackage?.defaultConvertersAmount?.value,
      minimumConvertersAmount: selectedPackage?.minimumConvertersAmount?.value,
      programDetailsLink: selectedPackage?.programDetailsLink?.value,
      connectionAgreementLink:selectedPackage?.connectionAgreementLink?.value
    });
  };
